import React, { useState } from "react";

import { HEADER_STRINGS } from "constants/constantStrings";

import SortIcon from "assets/SvgIcon/SortIcon";

import "./index.scss";

const ToggleSort = ({ toggleSorting }) => {
  const [isDescending, setIsDescending] = useState(true);
  const clickHandler = () => {
    setIsDescending(!isDescending);
    toggleSorting();
  };
  return (
    <div className="sort-container">
      <div className="label">{HEADER_STRINGS.sort}</div>
      <div onClick={clickHandler}>
        <SortIcon sortOrder={isDescending ? "desc" : "asc"} />
      </div>
    </div>
  );
};

export default ToggleSort;
